import { FieldNamesMarkedBoolean } from 'react-hook-form';

import { weekDaysToSeconds } from 'utils';

import { ALL_WEEK_DAYS } from './constants';
import { IFormValues, TUpdatePayload } from './interfaces';

export const prepareUpdatePayload = (
  values: IFormValues,
  dirtyFields: Partial<Readonly<FieldNamesMarkedBoolean<IFormValues>>>
): TUpdatePayload => {
  const updatePayload: TUpdatePayload = {};

  if (dirtyFields.title) {
    updatePayload.title = values.title;
  }

  if (dirtyFields.value) {
    updatePayload.value = values.value;
  }

  if (dirtyFields.is_tracked) {
    updatePayload.is_tracked = values.is_tracked;
  }

  if (dirtyFields.active) {
    updatePayload.active = values.active;
  }

  if (dirtyFields.dont_use_on_holidays) {
    updatePayload.dont_use_on_holidays = values.dont_use_on_holidays;
  }

  if (dirtyFields.days || dirtyFields.hours) {
    const validatedDays = values?.days.length ? values.days : ALL_WEEK_DAYS;
    const validatedHours = values?.hours?.start
      ? values.hours
      : { start: '00:00', end: '00:00' };

    updatePayload.schedules = weekDaysToSeconds(validatedHours, validatedDays);
  }

  return updatePayload;
};
